<style type="text/css" media="screen" scoped>
.input-block{
  border: 1px solid #E2E2E2;
  box-sizing: border-box;
  border-radius: 6px;
  width: 38px;
  height: 38px;
  padding: 10px;
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #303030;
}
.input-block:focus{
  border: 2px solid #1DC895 !important;
  /*background-color: #1DC895;*/
  /*color: #FFFF;*/
}
.input-block-wrapper{
  width: 45px;
  height: 45px;
  display: inline-block;
}
</style>

<template>
 <div class="text-center">
   <v-dialog v-model="dialog.flag" persistent width="520" class="br-25" >
    <v-card>
      <!--  close btn -->
      <p class="text-right pr-3" style="margin-bottom:-10px !important">
        <v-icon color="#8F8F8F" small @click="dialog.flag=false">
          mdi-window-close
        </v-icon>
      </p>
      <v-card-text class="flex-column  mb-5 " v-if="dialog.trip">
        <!--  dialog title -->
        <p class="page-title text-center">{{$lang.VERIFICATION.toUpperCase()}}</p>

        <div class="mt-8">
          <v-row class="">
            <v-col md="6" class="pt-0">
              <div class="d-flex flex-row pt-0 text-left"  flat >
                <div>
                  <img src="@/assets/calender.svg"  alt="img"  width="18px" class="mt-3">
                </div>
                <div class="pa-2 pt-0">
                  <p class="secodry-text-2">{{$lang.DATE}}</p>
                  <p class="sub-title-text text-center">{{dialog.trip.created_date}}, {{dialog.trip.created_time}}</p>
                </div>
              </div>
            </v-col>
          </v-row >
          <v-row >
            <v-col md="8" class="pt-0">
              <p class="filter-sub-title">{{$lang.AMOUNT}}</p>
              <p class="sub-title-text">
                <img src="@/assets/rupee.svg"  alt="img"  width="11px" class="" style="margin-right:-5px">
                {{dialog.trip.trip_collection_amount}}
              </p>
            </v-col>
            <v-col md="4" class="pt-0">
              <div class="d-flex flex-row pt-0">
                <div>
                  <img src="@/assets/return-green.svg"  alt="img"  width="18px" class="mt-5">
                </div>
                <div class="pa-2 pt-0"  >
                  <p class="secodry-text-2">{{$lang.RETURNS}}</p>
                  <p class="sub-title-text text-center">{{dialog.trip.return_shipment_count}}</p>
                </div>
              </div>
            </v-col>
          </v-row >
          <div class="text-left mt-4"> 
            <p class="secodry-text-2 mb-1">{{$lang.OTP.toUpperCase()}}</p>

            <otp-block  input-classes="small-input-block" @on-complete="getOtp"/>
            <p class="secodry-text-2 mt-2 fw-550 fs-10">{{$lang.COLLECTION_OTP_NOTES}}</p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="text-center pb-5">
        <v-spacer></v-spacer>
        <v-btn color="primary" width="90" class="fw-bold ml-5" 
        :disabled="otp.length!=6?true:false"
        :loading="btn_loading"   @click="verifyCollection">  
        {{$lang.CONTINUE}}
      </v-btn>  
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>
</div>
</template>


<script>
export default {
  props:["dialog"],
  components: {
    OtpBlock: () => import('@/components/common-components/opt-input-box/OtpBlock.vue'),
  },
  data () {
    return {
      recipient_name:"",
      btn_loading:false,
      otp:"",

    }
  },
  methods: {
    /* get otp from the data*/ 
    getOtp(otp){
      this.otp=otp
      if (this.otp.length==6){
				this.verifyCollection()
			}
    },

    /* Verify Withdrawal an dgenerate reqest to warehouse  */ 
    verifyCollection(){
      const self=this;
      self.btn_loading=true
      var form = new FormData();
      form.append("otp",this.otp);
      form.append("transaction_id",this.dialog.transaction_id);

      const successHandler = (response) => {
        if (response.data.success){
          this.dialog.flag=false
          this.$router.push({name:'collection-details',params:{transaction_id:this.encript(this.dialog.transaction_id)}})
        }
      };
      const finallyHandler = () => {
        self.btn_loading=false
      };
      
      this.request_POST(self,self.$urls.VERIFY_DEPOSIT,form,successHandler,null,null,finallyHandler) 

    },

  }
}
</script>